import { ReactNode } from 'react';
import { InboxIcon, SearchIcon, FileIcon, UsersIcon, PackageIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

type EmptyStateIcon = 'inbox' | 'search' | 'file' | 'users' | 'package';

const icons: Record<EmptyStateIcon, typeof InboxIcon> = {
  inbox: InboxIcon,
  search: SearchIcon,
  file: FileIcon,
  users: UsersIcon,
  package: PackageIcon,
};

interface EmptyStateProps {
  title?: string;
  description?: string;
  icon?: EmptyStateIcon;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({
  title = 'No data found',
  description = 'There are no items to display at the moment.',
  icon = 'inbox',
  action,
  className,
}: EmptyStateProps) {
  const IconComponent = icons[icon];

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center py-12 px-4 text-center',
        className
      )}
    >
      <div className="mb-4 rounded-full bg-muted p-3">
        <IconComponent className="h-6 w-6 text-muted-foreground" />
      </div>
      <h3 className="text-lg font-medium text-foreground">{title}</h3>
      <p className="mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
